import {isNil} from 'ramda';

import {LeasingRateMatrixCell, SaveSaleVehicleLeasingBody} from '@dms/api/vehicle';

import {isActiveLeasingCell} from './isActiveLeasingCell';
import {isSameLeasingCell} from './isSameLeasingCell';

/**
 * Writes one cell into the leasing rate matrix, replacing whatever the position held.
 *
 * The edited cell becomes the active variant when the user asked for it, and also when the matrix
 * has no active variant left to keep — a matrix that holds cells must advertise one of them.
 */
export function updateLeasingCell(
  vehicleLeasingBody: SaveSaleVehicleLeasingBody,
  nextCell: LeasingRateMatrixCell,
  setActive: boolean
): SaveSaleVehicleLeasingBody {
  const nextCells = [
    ...vehicleLeasingBody.rateMatrixCells.filter((cell) => !isSameLeasingCell(cell, nextCell)),
    nextCell,
  ];
  const currentActiveCell = nextCells.find((cell) => isActiveLeasingCell(vehicleLeasingBody, cell));
  const nextActiveCell = setActive || isNil(currentActiveCell) ? nextCell : currentActiveCell;

  return {
    ...vehicleLeasingBody,
    activeTerm: nextActiveCell.term,
    activeAnnualMileage: nextActiveCell.annualMileage,
    rateMatrixCells: nextCells,
  };
}
